var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyInvestIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.722,
    height: 21.722,
    viewBox: "0 0 21.722 21.722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "why-invest-icon-4",
    d: "M22.308,3H5.414A2.421,2.421,0,0,0,3,5.414V22.308a2.421,2.421,0,0,0,2.414,2.414H22.308a2.421,2.421,0,0,0,2.414-2.414V5.414A2.421,2.421,0,0,0,22.308,3Zm-10,16.038a1.2,1.2,0,0,1-1.7,0L6.27,14.706a1.2,1.2,0,0,1,1.7-1.7l3.475,3.475,8.3-8.3a1.2,1.2,0,0,1,1.7,1.7L12.3,19.038Z",
    transform: "translate(-3 -3)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyInvestIcon4);
export default __webpack_public_path__ + "static/media/why-invest-icon-4.a3791b64b00da827febbae70a9afbdad.svg";
export { ForwardRef as ReactComponent };